import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import * as ptLocale from 'date-fns/locale/pt';
import { LoadingService } from '../../../util/loader.service';
import { MultiplasLojasService } from './multiplas-lojas.service';
import { FormBuilder } from '@angular/forms';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ModalOptions, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
//import { ModalConfiguracaoCartaoComponent } from './modal-configuracao-cartao/modal-configuracao-cartao.component';
const swal = require('sweetalert');
import { moment } from 'ngx-bootstrap/chronos/test/chain';


@Component({
  selector: 'app-multiplas-lojas',
  templateUrl: './multiplas-lojas.component.html',
  styleUrls: ['./multiplas-lojas.component.scss']
})
export class MultiplasLojasComponent implements OnInit {
  selectCheck;
  selected: any[] = [];
  isSelected;
  public modalRef: BsModalRef;
  filterState: boolean = true;
  rows: Object[];
  registroSelecao: any[] = [];
  parametroConsulta: string;
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: "",
    state: true,
  };
  mesagensGrid = {
    'emptyMessage': 'Nenhum dado para exibir',
    'totalMessage': 'Total de registros',
    'selectedMessage': 'Selecionado'
  };
  acoesBottoes: boolean = true;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  sortDir: string = "";
  sortProp: string = "";

  constructor(private service: MultiplasLojasService, private router: Router, public loader: LoadingService, public fb: FormBuilder, private _localeService: BsLocaleService, private modalService: BsModalService) {

    this.reloadTable();
  }

  ngOnInit() {
  }
  reloadTable() {
    this.loader.show("body");
    this.service.obterTodos(this.page, this.sortDir, this.sortProp)
      .subscribe((itens) => {
        this.loader.hide("body");
        this.page.count = itens.count;
        this.rows = itens.rows;
      });

  }

  onFilterChange(eve: any) {
    this.limparSelecionados();
    this.page.state = eve;
    this.reloadTable();
  }
  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];
    this.acoesBottoes = true;
  }

  linkNovo() {
    this.router.navigate(['/fidel/gerir-lojas/nova-empresa']);
  }

  openModalCartao(event) {

   /* const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      class: 'modal-lg',
      // size: 'lg', // sm, md, lg
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(ModalConfiguracaoCartaoComponent, config);

    this.modalRef.content.onClose.subscribe(result => {
      this.reloadTable();
      this.registroSelecao = [];
      this.selected = [];
    });*/

  }

  editarCartao(event) {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.router.navigate([`/fidel/gerir-lojas/detalhe/${this.registroSelecao[0].id_empresa}`]);
    }
  }


  inativarCartao() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      if (this.registroSelecao[0].vencido || this.registroSelecao[0].inativado) {
        swal('Atenção', 'Cartão vencido ou desativado.', 'warning');
      } else {
        swal({
          title: 'Atenção',
          text: 'Você deseja desativar esse cartão fidelidade?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1E0136',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          closeOnConfirm: false
        }, () => {
          swal.close();

          this.service.inativarCartao(this.registroSelecao[0].id_cartao)
            .subscribe(result => {
              this.loader.hide("body");
              if (result.id_cartao != null) {
                this.reloadTable();
                this.limparSelecionados();
                swal('Atenção', 'Ação realizada com sucesso.', 'success');
              }
            });
        });
      }
    }
  }
  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }
  
  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);

    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }
  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.id_empresa == codigo) {
        x = true;
      }
    });
    return x;
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].codigo == item[0].codigo) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }
  onSort(event) {
    this.sortDir = event.sorts[0].dir;
    this.sortProp = event.sorts[0].prop;
    this.page.offset = 0;
    this.reloadTable();
  }
}
